let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kejEt"), load("cEoso"), load("2u53D"), load("l1QPP"), load("hMDX9"), load("fOegz")]).then(() => parcelRequire('hiMwI'));